import { IResa } from './resa.i';
import { IFormInfo } from '../formation/formation.i';
import { ISessionInfo } from '../session/session.i';
import { IContact } from '../user/user.i';

export class CResa implements IResa {
  id = 0;
  id_prc = null;
  id_client = 0;
  formation: IFormInfo = undefined;
  selected_session: ISessionInfo = undefined;
  session_list: ISessionInfo[] = [];
  participants: IContact[] = [];
  nb_places = 0;
  price = 0;
  nb_places_reserve = 0;

  constructor(source?: IResa) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        id_prc: source.id_prc,
        id_client: source.id_client,
        formation: source.formation,
        selected_session: source.selected_session,
        session_list: source.session_list ? [...source.session_list] : source.session_list,
        participants: source.participants ? [...source.participants] : source.participants,
        nb_places: source.nb_places,
        nb_places_reserve: source.nb_places_reserve,
        price: source.price
      });
    }
  }
}
